import { BaseFetch } from "../main-model";
export default class ExportPP2Model extends BaseFetch {
  getExportPP2By = (data) =>
    this.authFetch({
      url: "export-pp2/getExportPP2By",
      method: "POST",
      body: JSON.stringify(data),
    });
}
